import gql from 'graphql-tag';
import { TypedDocumentNode } from '@apollo/client/core';
import {
	IAssigneeOrganization,
	IAssigneeUser,
} from '@shared/interfaces/selectable-options.interfaces';

export const SelectableOptionsQuery = gql`
	query SelectableOptionsQuery {
		availableVariables
	}
`;

const UserFragment: TypedDocumentNode<IAssigneeUser, Record<string, never>> = gql`
	fragment AssigneeUser on ProfileType {
		avatarUrl
		contentType
		countryCode
		displayName
		email
		firstName
		imageUrl
		lastName
		phoneNumber
		psId
		smallAvatarUrl
		userRole
	}
`;

export const SelectableAssigneesQuery: TypedDocumentNode<
	{ organizations: IAssigneeOrganization[] },
	Record<string, never>
> = gql`
	query SelectableAssigneesQuery {
		organizations {
			contentType
			id
			logoUrl
			name
			permissionLevel
			psId
			teams {
				contentType
				name
				permissionLevel
				psId
				smallLogoUrl
				teamType
				users {
					...AssigneeUser
				}
			}
			type
			users {
				...AssigneeUser
			}
		}
	}
	${UserFragment}
`;
